class CartManager {
    static texts = {
        DE: {
            added: 'Artikel wurde hinzugefügt!',
            viewCart: 'Zum Warenkorb',
            continueShopping: 'Weiter einkaufen',
            error: 'Fehler'
        },
        EN: {
            added: 'Item added to cart!',
            viewCart: 'View Cart',
            continueShopping: 'Continue Shopping',
            error: 'Error'
        },
        ES: {
            added: '¡Artículo añadido al carrito!',
            viewCart: 'Ver carrito',
            continueShopping: 'Seguir comprando',
            error: 'Error'
        }
    };

    constructor() {
        this.initCartFormHandler();
    }

    initCartFormHandler() {
        const selector = 'form[action="/cart/add"]:not([data-type="add-to-cart-form"])';

        $(document).off('submit.ktCartManager', selector).on('submit.ktCartManager', selector, (e) => {
            if (e.currentTarget.closest('product-form')) {
                return;
            }

            e.preventDefault();
            e.stopImmediatePropagation();

            const form = $(e.currentTarget);
            const shopLocale = (window.Shopify && Shopify.locale) ? Shopify.locale.toUpperCase() : 'DE';
            const locale = CartManager.texts[shopLocale] ? shopLocale : 'DE';

            this.addToCart(form[0], locale);
        });
    }

    addToCart(formElement, locale) {
        const t = CartManager.texts[locale] || CartManager.texts.EN;
        const formData = new FormData(formElement);

        if (!formData.has('quantity')) {
            formData.append('quantity', 1);
        }

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Accept': 'application/json'
            },
            body: formData
        })
            .then((res) => res.json())
            .then((response) => {

                // Shopify Fehler?
                if (response.status) {
                    this.showErrorPopup(t, response);
                    return;
                }

                this.updateCartBubble();

                // Popup anzeigen
                this.showSuccessPopup(t);

            })
            .catch((error) => {
                console.error(error);
                this.showErrorPopup(t, error);
            });
    }

    updateCartBubble() {
        fetch('/?sections=cart-icon-bubble')
            .then((response) => response.json())
            .then((sections) => {
                const cartIconBubble = document.querySelector('#cart-icon-bubble');
                const sectionHTML = sections && sections['cart-icon-bubble'];

                if (!cartIconBubble || !sectionHTML) {
                    throw new Error('cart-icon-bubble section missing');
                }

                const renderedBubble = new DOMParser()
                    .parseFromString(sectionHTML, 'text/html')
                    .querySelector('.shopify-section');

                if (!renderedBubble) {
                    throw new Error('cart-icon-bubble markup missing');
                }

                cartIconBubble.innerHTML = renderedBubble.innerHTML;
            })
            .catch(() => this.updateCartBubbleSimple());
    }

    updateCartBubbleSimple() {
        fetch('/cart.js')
            .then(r => r.json())
            .then(cart => {
                const cartIconBubble = document.querySelector('#cart-icon-bubble');
                if (!cartIconBubble) {
                    return;
                }

                let countBubble = cartIconBubble.querySelector('.cart-count-bubble');

                if (cart.item_count === 0) {
                    if (countBubble) {
                        countBubble.remove();
                    }
                    return;
                }

                if (!countBubble) {
                    countBubble = document.createElement('div');
                    countBubble.className = 'cart-count-bubble';
                    cartIconBubble.appendChild(countBubble);
                }

                const displayCount = cart.item_count < 100 ? cart.item_count : '';
                countBubble.innerHTML = `
                    ${displayCount !== '' ? `<span aria-hidden="true">${displayCount}</span>` : ''}
                    <span class="visually-hidden">${this.getCartCountText(cart.item_count, countBubble)}</span>
                `;
            })
            .catch(() => {});
    }

    getCartCountText(itemCount, countBubble) {
        const existingText = countBubble && countBubble.querySelector('.visually-hidden') &&
            countBubble.querySelector('.visually-hidden').textContent.trim();

        if (existingText && /\d+/.test(existingText)) {
            return existingText.replace(/\d+/, itemCount);
        }

        const locale = (document.documentElement.lang || (window.Shopify && Shopify.locale) || 'de').slice(0, 2).toLowerCase();

        if (locale === 'en') {
            return itemCount === 1 ? '1 item' : `${itemCount} items`;
        }

        if (locale === 'es') {
            return itemCount === 1 ? '1 artículo' : `${itemCount} artículos`;
        }

        return itemCount === 1 ? '1 Artikel' : `${itemCount} Artikel`;
    }

    showSuccessPopup(texts) {
        Swal.fire({
            title: texts.added,
            icon: 'success',
            showCancelButton: true,
            confirmButtonText: texts.viewCart,
            cancelButtonText: texts.continueShopping,
            timer: 2000
        }).then((result) => {
            if (result.isConfirmed) {
                window.location.href = '/cart';
            }
        });
    }

    showErrorPopup(texts, error) {
        let message = texts.error;

        // Shopify-Response-Objekt
        if (error && typeof error === 'object') {
            if (error.description) {
                message = error.description;
            } else if (error.message) {
                message = error.message;
            }
        }

        Swal.fire({
            title: texts.error,
            text: message,
            icon: 'error'
        });
    }
}
